/* ================================================================
   LP Scripts — Landing Page JS for PARK Styling
   Single file, loaded once via lp-hero.liquid.
   ================================================================ */

/* ——— LP PRIME INFO TOGGLE ——— */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lp-prime-toggle]');
    if (!btn) return;
    var container = btn.closest('.lp-pricing-box') || btn.closest('[data-lp-bundle]');
    if (!container) return;
    var info = container.parentElement.querySelector('[data-lp-prime-info]');
    if (!info) return;
    info.hidden = !info.hidden;
  });
})();

/* ——— LP VIDEO AUTOPLAY FALLBACK ——— */
(function () {
  'use strict';
  function playVideos() {
    try {
      document.querySelectorAll('[data-lp-video]').forEach(function (video) {
        if (video.paused) {
          video.play().catch(function () {});
        }
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', playVideos);
  } else {
    playVideos();
  }
})();

/* ——— LP CAROUSEL ——— */
(function () {
  'use strict';

  function initCarousels() {
    try {
    document.querySelectorAll('.lp-carousel').forEach(function (carousel) {
      var slides = carousel.querySelectorAll('.lp-carousel-slide');
      var prevBtn = carousel.querySelector('.lp-carousel-arrow.prev');
      var nextBtn = carousel.querySelector('.lp-carousel-arrow.next');
      var thumbs = carousel.closest('.lp-section')
        ? carousel.closest('.lp-section').querySelectorAll('.lp-thumb[data-slide]')
        : [];
      var currentIndex = 0;

      if (slides.length < 2) return;

      function goToSlide(index) {
        slides[currentIndex].classList.remove('active');
        currentIndex = (index + slides.length) % slides.length;
        slides[currentIndex].classList.add('active');
        thumbs.forEach(function (t) {
          t.classList.toggle('active', parseInt(t.dataset.slide, 10) === currentIndex);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentIndex + 1); });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToSlide(parseInt(thumb.dataset.slide, 10));
        });
      });
    });
    } catch (err) { console.error('LP carousel init failed:', err); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();

/* ——— LP REVEAL / COLLAPSIBLE ——— */
(function () {
  'use strict';

  function initReveal() {
    try {
    document.querySelectorAll('[data-lp-reveal]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var teaser = btn.closest('[data-lp-teaser]');
        var targets = document.querySelectorAll('[data-lp-group="collapsible"]');

        if (teaser) teaser.style.display = 'none';

        targets.forEach(function (el) {
          el.classList.remove('lp-hidden');
        });

        if (targets.length > 0) {
          setTimeout(function () {
            targets[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      });
    });
    } catch (err) { console.error('LP reveal init failed:', err); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

/* ——— LP REVIEWS CAROUSEL ——— */
(function () {
  'use strict';

  var initialized = new WeakSet();

  function setupCarousel(container) {
    if (initialized.has(container)) return;
    initialized.add(container);

    var track = container.querySelector('[data-lp-reviews-track]');
    var originalCards = Array.prototype.slice.call(track.querySelectorAll('.lp-review-card'));
    var dotsWrap = container.querySelector('[data-lp-reviews-dots]');
    var dots = container.querySelectorAll('.lp-reviews-dot');
    var prevBtn = container.querySelector('[data-lp-reviews-prev]');
    var nextBtn = container.querySelector('[data-lp-reviews-next]');
    var autoplaySpeed = parseInt(container.dataset.autoplay, 10) || 0;
    var total = originalCards.length;

    if (total < 2) return;

    /* For infinite loop on desktop: duplicate cards so track always fills.
       E.g. 5 cards → we need at least 2 pages of 3 = 6, so we clone 1 extra.
       We clone the full set once to ensure smooth looping. */
    var desktopCloned = false;
    function ensureClones() {
      if (desktopCloned) return;
      var perPage = mobile() ? 1 : 3;
      if (perPage === 1) return;
      /* Clone enough cards to fill the last page */
      var remainder = total % perPage;
      if (remainder > 0) {
        for (var c = 0; c < perPage - remainder; c++) {
          var clone = originalCards[c].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }
      }
      desktopCloned = true;
    }

    var current = 0;
    var timer = null;

    function mobile() { return window.innerWidth < 900; }
    function pages() {
      if (mobile()) return total;
      ensureClones();
      var allCards = track.querySelectorAll('.lp-review-card');
      return Math.ceil(allCards.length / 3);
    }

    function goTo(i) {
      var p = pages();
      current = ((i % p) + p) % p;

      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      /* Update dots */
      dots.forEach(function (d, idx) {
        if (mobile()) {
          d.style.display = '';
          d.classList.toggle('active', idx === current);
        } else {
          d.style.display = idx < p ? '' : 'none';
          d.classList.toggle('active', idx === current);
        }
      });

      var multi = p > 1;
      if (dotsWrap) dotsWrap.style.display = multi ? '' : 'none';
      if (prevBtn) prevBtn.style.display = multi && !mobile() ? '' : 'none';
      if (nextBtn) nextBtn.style.display = multi && !mobile() ? '' : 'none';
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      stopAutoplay();
      if (autoplaySpeed > 0 && pages() > 1) {
        timer = setInterval(next, autoplaySpeed * 1000);
      }
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); next(); startAutoplay(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        var target = parseInt(dot.dataset.dot, 10);
        if (!mobile()) target = Math.min(target, pages() - 1);
        goTo(target);
        startAutoplay();
      });
    });

    var startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 50) { diff > 0 ? next() : prev(); }
      startAutoplay();
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(0); }, 250);
    });

    goTo(0);
    startAutoplay();
  }

  function initAll() {
    try {
      document.querySelectorAll('[data-lp-reviews]').forEach(setupCarousel);
    } catch (err) { console.error('LP reviews init failed:', err); }
  }

  /* Standard init */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-init when collapsible sections are revealed */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lp-reveal]')) {
      setTimeout(initAll, 150);
    }
  });

  /* Shopify theme editor events */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();

/* ——— LP BUNDLE: SHARED LOGIC (used by page bundle + modal) ——— */
var LPBundle = (function () {
  'use strict';

  function formatPrice(priceInMinor) {
    var amount = priceInMinor / 100;
    if (amount % 1 === 0) return amount + ' kr.';
    return amount.toFixed(2).replace('.', ',') + ' kr.';
  }

  function findBundleVariant(bundleVariants, bundleOptions, selections) {
    if (!bundleVariants || !bundleOptions || selections.length === 0) return null;

    var optionMatches = [];
    selections.forEach(function (sel) {
      for (var i = 0; i < bundleOptions.length; i++) {
        if (bundleOptions[i].name.indexOf(sel.productTitle) !== -1) {
          optionMatches.push({ position: i, value: sel.optionValue });
          break;
        }
      }
    });

    for (var v = 0; v < bundleVariants.length; v++) {
      var variant = bundleVariants[v];
      if (!variant.available) continue;
      var allMatch = true;
      for (var m = 0; m < optionMatches.length; m++) {
        if (variant.options[optionMatches[m].position] !== optionMatches[m].value) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) return variant;
    }
    return null;
  }

  function addToCart(items, onSuccess) {
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer' })
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart error: ' + response.status);
      return response.json();
    })
    .then(function () {
      if (onSuccess) onSuccess();
      document.dispatchEvent(new CustomEvent('theme:cartchanged', {
        detail: { openDrawer: true }
      }));
    });
  }

  /**
   * Initialize bundle variant selection, price calc & add-to-cart
   * on a given [data-lp-bundle] container.
   * @param {Element} bundle - The bundle container element
   * @param {Object} [opts] - Options
   * @param {Function} [opts.onAddSuccess] - Called after successful add-to-cart
   */
  function init(bundle, opts) {
    opts = opts || {};
    var totalEl = bundle.querySelector('[data-lp-total-price]');
    var primeEl = bundle.querySelector('[data-lp-prime-price]');
    var addBtn = bundle.querySelector('[data-lp-add-to-cart]');

    var bundleVariants = null;
    var bundleOptions = null;
    var variantsEl = bundle.querySelector('[data-lp-bundle-variants]');
    var optionsEl = bundle.querySelector('[data-lp-bundle-options]');
    if (variantsEl) { try { bundleVariants = JSON.parse(variantsEl.textContent); } catch (e) { console.error('LP bundle: failed to parse variants JSON', e); } }
    if (optionsEl) { try { bundleOptions = JSON.parse(optionsEl.textContent); } catch (e) { console.error('LP bundle: failed to parse options JSON', e); } }

    var hasBundleProduct = bundleVariants && bundleVariants.length > 0;

    if (!totalEl || !primeEl) return;

    function getMatchedBundleVariant() {
      var selections = [];
      bundle.querySelectorAll('[data-lp-product-block]').forEach(function (block) {
        var variantGroup = block.querySelector('[data-lp-variants]');
        if (!variantGroup) return;
        var active = variantGroup.querySelector('.lp-size-btn.active');
        if (active) {
          selections.push({
            productTitle: block.dataset.lpProductTitle,
            optionValue: active.dataset.optionValue
          });
        }
      });
      return findBundleVariant(bundleVariants, bundleOptions, selections);
    }

    function recalc() {
      if (hasBundleProduct) {
        var matched = getMatchedBundleVariant();
        if (matched) {
          totalEl.textContent = formatPrice(matched.price);
          primeEl.textContent = formatPrice(Math.round(matched.price * 0.8));
        }
      } else {
        var total = 0;
        bundle.querySelectorAll('[data-lp-variants]').forEach(function (group) {
          var active = group.querySelector('.lp-size-btn.active');
          if (active) total += parseInt(active.dataset.price, 10);
        });
        bundle.querySelectorAll('[data-lp-single-variant]').forEach(function (input) {
          var block = input.closest('[data-lp-product-block]');
          if (block && block.querySelector('.lp-free')) return;
          total += parseInt(input.dataset.price, 10);
        });
        totalEl.textContent = formatPrice(total);
        primeEl.textContent = formatPrice(Math.round(total * 0.8));
      }
    }

    bundle.querySelectorAll('[data-lp-variants]').forEach(function (group) {
      var btns = group.querySelectorAll('.lp-size-btn');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          recalc();
        });
      });
    });

    recalc();

    if (!addBtn) return;

    addBtn.addEventListener('click', function () {
      var items = [];

      if (hasBundleProduct) {
        var matched = getMatchedBundleVariant();
        if (!matched) {
          console.error('LP bundle: no matching variant found');
          return;
        }
        items.push({ id: matched.id, quantity: 1 });
      } else {
        bundle.querySelectorAll('[data-lp-variants]').forEach(function (group) {
          var active = group.querySelector('.lp-size-btn.active');
          if (active && active.dataset.variantId) {
            items.push({ id: parseInt(active.dataset.variantId, 10), quantity: 1 });
          }
        });
        bundle.querySelectorAll('[data-lp-single-variant]').forEach(function (input) {
          if (input.dataset.variantId) {
            items.push({ id: parseInt(input.dataset.variantId, 10), quantity: 1 });
          }
        });
      }

      if (items.length === 0) return;

      addBtn.disabled = true;
      var btnText = addBtn.querySelector('[data-lp-btn-text]');
      var btnLoading = addBtn.querySelector('[data-lp-btn-loading]');
      if (btnText) btnText.style.display = 'none';
      if (btnLoading) btnLoading.style.display = 'inline-flex';

      addToCart(items, opts.onAddSuccess)
      .catch(function (err) {
        console.error('LP add to cart failed:', err);
        var errorEl = bundle.querySelector('[data-lp-cart-error]');
        if (!errorEl) {
          errorEl = document.createElement('div');
          errorEl.setAttribute('data-lp-cart-error', '');
          errorEl.setAttribute('role', 'alert');
          addBtn.parentNode.insertBefore(errorEl, addBtn.nextSibling);
        }
        errorEl.className = 'lp-cart-error';
        errorEl.textContent = 'Der opstod en fejl. Prøv igen.';
        setTimeout(function () { errorEl.textContent = ''; }, 5000);
      })
      .finally(function () {
        addBtn.disabled = false;
        if (btnText) btnText.style.display = '';
        if (btnLoading) btnLoading.style.display = 'none';
      });
    });
  }

  return { init: init };
})();

/* ——— LP BUNDLE: PAGE INIT (Final CTA section) ——— */
(function () {
  'use strict';

  function initBundles() {
    try {
      document.querySelectorAll('[data-lp-bundle]').forEach(function (bundle) {
        LPBundle.init(bundle);
      });
    } catch (err) { console.error('LP bundle init failed:', err); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundles);
  } else {
    initBundles();
  }
})();

/* ——— LP STICKY MODAL ——— */
(function () {
  'use strict';

  function closeModal(overlay, triggerBtn) {
    overlay.classList.remove('active');
    document.body.classList.remove('lp-modal-open');
    document.removeEventListener('keydown', overlay._lpEscHandler);
    overlay.addEventListener('transitionend', function handler() {
      overlay.setAttribute('hidden', '');
      overlay.removeEventListener('transitionend', handler);
      if (triggerBtn) triggerBtn.focus();
    });
  }

  function initModal() {
    try {
      var overlay = document.querySelector('[data-lp-modal]');
      if (!overlay) return;

      var closeBtn = overlay.querySelector('[data-lp-modal-close]');
      var modalBody = overlay.querySelector('[data-lp-modal-body]');
      var populated = false;
      var lastTrigger = null;

      function handleKeydown(e) {
        if (e.key === 'Escape') { closeModal(overlay, lastTrigger); return; }
        if (e.key === 'Tab') {
          var focusable = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (focusable.length === 0) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      overlay._lpEscHandler = handleKeydown;

      function openModal() {
        if (!populated) {
          var source = document.querySelector('.lp-final-cta [data-lp-bundle]');
          if (!source) return;
          var clone = source.cloneNode(true);
          modalBody.appendChild(clone);
          populated = true;
          LPBundle.init(clone, {
            onAddSuccess: function () { closeModal(overlay, lastTrigger); }
          });
        }
        overlay.removeAttribute('hidden');
        requestAnimationFrame(function () {
          overlay.classList.add('active');
          if (closeBtn) closeBtn.focus();
        });
        document.body.classList.add('lp-modal-open');
        document.addEventListener('keydown', handleKeydown);
      }

      /* Sticky mobile button + all CTAs marked with data-lp-bundle-cta */
      document.querySelectorAll('[data-lp-open-modal], [data-lp-bundle-cta]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          lastTrigger = btn;
          openModal();
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', function () { closeModal(overlay, lastTrigger); });
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeModal(overlay, lastTrigger);
      });
    } catch (err) { console.error('LP modal init failed:', err); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModal);
  } else {
    initModal();
  }
})();
